import { axiosBitrixInstance } from "../../../utils/axios/requestInfo";
import { api } from "../../../resources/api";

export const getFamilyPurchaseHistory = async (
  partnerIds: string[],
  startDate: string = "2021-01-01T00:00:00"
) => {
  try {
    const response = await axiosBitrixInstance.post(
      api.bitrix.GET_FAMILY_PURCHASE_HISTORY,
      {
        partnerIds: partnerIds,
        startDate: startDate,
      }
    );

    return response.data?.body || { rents: [], memberships: [] };
  } catch (error) {
    throw error;
  }
};

export const getActiveMemberships = async () => {
  try {
    const response = await axiosBitrixInstance.get(
      api.bitrix.GET_ACTIVE_MEMBERSHIPS
    );

    return response.data?.body || [];
  } catch (error) {
    throw error;
  }
};
